import { useEffect } from 'react'

import Button from 'react-bootstrap/Button'

import { useWhatsNew } from './WhatsNewProvider'

const WhatsNewButton = () => {
  const { count, openFeed, hintVisible, dismissHint } = useWhatsNew()

  useEffect(() => {
    if (!hintVisible) return undefined
    const onPointerDown = (event) => {
      if (event.target.closest?.('.whats-new-nav')) return
      dismissHint()
    }
    document.addEventListener('pointerdown', onPointerDown)
    return () => document.removeEventListener('pointerdown', onPointerDown)
  }, [dismissHint, hintVisible])

  return (
    <div className="whats-new-nav">
      <Button
        id="whats-new-button"
        type="button"
        variant="light"
        className="whats-new-nav__button"
        onClick={openFeed}
        aria-label={
          count > 0 ? `What's new, ${count} new features` : "What's new"
        }
      >
        <svg
          className="whats-new-nav__icon"
          viewBox="0 0 24 24"
          aria-hidden="true"
        >
          <path d="M12 0C12 6.627 6.627 12 0 12 6.627 12 12 17.373 12 24 12 17.373 17.373 12 24 12 17.373 12 12 6.627 12 0z" />
        </svg>
        What's new
        {count > 0 && <span className="whats-new-nav__count">{count}</span>}
      </Button>
      {hintVisible && (
        <div className="whats-new-hint" role="status">
          Release notes live here. Open them anytime.
        </div>
      )}
    </div>
  )
}

export default WhatsNewButton
